var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartnersBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_514_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#33295B"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_514_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1190.23 553.395C1184.7 551.929 1054.68 516.977 921.598 430.762C732.433 308.206 630.561 142.674 626.996 -47.9238L817.219 -51.9794C819.448 67.2121 887.758 171.146 1020.26 256.985C1127.08 326.162 1236.23 356.177 1237.32 356.46L1190.23 553.395Z",
    fill: "#656DF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M968.577 385.835C794.078 272.784 693.934 123.144 676.642 -49.0022L626.996 -47.9238C630.556 142.695 732.427 308.227 921.593 430.782C1054.68 516.997 1184.68 551.95 1190.23 553.415L1204.43 498.422C1155.94 482.313 1062.71 446.814 968.577 385.835Z",
    fill: "#3C4090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1669.07 593.187L1586.54 410.045C1685.54 358.839 1945.18 177.854 1958.11 -41.7321L2148 -28.9719C2125.41 354.737 1687.7 583.636 1669.07 593.187Z",
    fill: "#656DF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2107.43 -31.6755C2055.38 297.267 1704.36 501.25 1642.72 534.721L1669.07 593.187C1687.69 583.636 2125.4 354.737 2148 -28.9512L2107.43 -31.6755Z",
    fill: "#3C4090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.04 402.734L1315.79 415.318C1315.79 415.318 1404.58 407.847 1412.33 408.311C1420.08 408.776 1588.18 653.113 1588.18 653.113C1588.18 653.113 1576.99 690.965 1532.81 683.768L1521.43 671.745C1521.43 671.745 1504.89 709.164 1474.33 693.076L1462.21 681.771C1462.21 681.771 1458.71 713.958 1422.91 702.812L1415.49 697.069C1415.49 697.069 1407.35 716.218 1382.33 707.905L1238.86 613.13L1191.69 542.281L1245.04 402.734Z",
    fill: "#F89B66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1368.89 700.052L1351.39 703.839C1351.39 703.839 1333.15 704.541 1329.65 690.94C1326.16 677.338 1339.87 657.974 1339.87 657.974C1339.87 657.974 1348.6 644.636 1360.73 652.592C1372.87 660.548 1377.76 674.867 1365.8 692.673L1368.89 700.052Z",
    fill: "#FFB482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.33 408.311L1358.3 449.358L1334.4 515.063C1334.4 515.063 1331.82 548.044 1373.17 538.328L1402.83 497.406L1472.68 487.798L1578.85 639.589L1654.91 583.549L1606.52 399.896L1550.11 416.639C1550.11 416.639 1479.41 389.488 1471.77 389.024C1464.13 388.56 1439.67 391.784 1412.33 408.311Z",
    fill: "#FFB482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.74 678.752L1342.42 647.226C1342.42 647.226 1354.47 623.269 1331.11 613.171C1307.75 603.073 1294.36 652.386 1292.32 661.596C1292.32 661.596 1286.88 677.204 1301.87 685.109C1316.86 693.014 1325.74 678.752 1325.74 678.752Z",
    fill: "#FFB482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.29 650.621L1312.77 603.032C1312.77 603.032 1324.83 579.06 1301.47 568.977C1278.11 558.895 1266.12 598.285 1260.05 615.885C1260.05 615.885 1243.08 645.157 1264.43 656.988C1279.27 665.239 1288.29 650.621 1288.29 650.621Z",
    fill: "#FFB482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.08 621.556L1266.76 590.024C1266.76 590.024 1278.81 566.052 1255.45 556C1232.09 545.949 1218.69 595.215 1216.65 604.415C1216.65 604.415 1211.2 620.023 1226.2 627.944C1241.2 635.864 1250.08 621.556 1250.08 621.556Z",
    fill: "#FFB482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1591.55 391.903L1653.71 603.187L1702.36 582.001L1649.9 367.611L1591.55 391.903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265.45 372.198L1181.4 574.648L1135.29 547.74L1210.04 341.033L1265.45 372.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635.29 426.314C1629.15 428.29 1622.67 424.57 1620.82 418.007C1618.98 411.474 1622.48 404.519 1628.59 402.527H1628.63C1634.77 400.556 1641.24 404.266 1643.08 410.814V410.845C1644.94 417.408 1641.46 424.338 1635.31 426.324L1635.29 426.314Z",
    fill: "#F8D6E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.8 401.026C1222.68 403.724 1229.55 400.794 1232.07 394.514C1234.61 388.204 1231.88 380.897 1225.97 378.188C1220.1 375.5 1213.24 378.431 1210.72 384.695V384.726C1208.19 390.995 1210.93 398.327 1216.8 401.015V401.026Z",
    fill: "#F8D6E7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_514_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_514_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1521,
    height: 762,
    fill: "white",
    transform: "translate(627 -52)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnersBg);
export default __webpack_public_path__ + "static/media/partners_bg.d58de7f0f184dddd6af0e6d7722cab07.svg";
export { ForwardRef as ReactComponent };